// Shifts master API — POST/GET/PATCH /shifts.
//
// Note: the backend mounts under /shifts (NOT /masters/shifts) since
// shifts are a system-level master used by HR, Production, Maintenance,
// and Quality — kept at the top level for consistency with the routes
// already wired in pages/hr/* that fetch from /shifts.
import apiClient from '@/shared/api/client'
import type { Shift } from '@/shared/types/master'

export interface ShiftCreate {
  plant_id: string
  shift_code: string
  shift_name: string
  start_time: string  // 'HH:MM:SS' or 'HH:MM'
  end_time: string
  is_night_shift?: boolean
  /** Total scheduled break minutes (lunch + tea + toilet). Default 60. */
  break_minutes?: number
  is_active?: boolean
}

export interface ShiftUpdate {
  shift_name?: string
  start_time?: string
  end_time?: string
  is_night_shift?: boolean
  break_minutes?: number
  is_active?: boolean
}

export const shiftsApi = {
  list: async (params?: { plant_id?: string; is_active?: boolean }): Promise<Shift[]> =>
    (await apiClient.get<Shift[]>('/shifts', { params })).data,

  get: async (id: string): Promise<Shift> =>
    (await apiClient.get<Shift>(`/shifts/${id}`)).data,

  create: async (body: ShiftCreate): Promise<Shift> =>
    (await apiClient.post<Shift>('/shifts', body)).data,

  update: async (id: string, patch: ShiftUpdate): Promise<Shift> =>
    (await apiClient.patch<Shift>(`/shifts/${id}`, patch)).data,
}
